export const SET_SEARCH_TERM = 'SET_SEARCH_TERM';
export const LOAD_SEARCH_AUTOCOMPLETE_DATA = 'LOAD_SEARCH_AUTOCOMPLETE_DATA';
export const SET_SEARCH_CATEGORY = 'SET_SEARCH_CATEGORY';
export const SET_SELECTEDSEARCH_OPTION = 'SET_SELECTEDSEARCH_OPTION';
export const RESET_SEARCH_DATA = 'RESET_SEARCH_DATA';
export const RESET_SEARCH_SEARCHTERM = 'RESET_SEARCH_SEARCHTERM';

//Results
export const LOAD_RESULTSVIEW_DATA = 'LOAD_RESULTSVIEW_DATA';
export const SET_ASSETS3D_DATA = 'SET_ASSETS3D_DATA';
export const SET_PRODUCTS_DATA = 'SET_PRODUCTS_DATA';
export const SET_STEPPER_STEPS = 'SET_STEPPER_STEPS';
export const SET_STEPPER_ACTIVE_STEP = 'SET_STEPPER_ACTIVE_STEP';
export const SET_AUTOCOMPLETE_LOADING = 'SET_AUTOCOMPLETE_LOADING';
export const RESET_RESULTSVIEW_DATA = 'RESET_RESULTSVIEW_DATA';
export const SET_RESULTSPAGE_SEARCHTERM = 'SET_RESULTSPAGE_SEARCHTERM';
export const RESULTS_ADD_SOURCE_FILE_TO_ASSET = 'RESULTS_ADD_SOURCE_FILE_TO_ASSET';
export const SET_ASSET_FILTERS = 'SET_ASSET_FILTERS';
export const SET_PRODUCT_FILTERS = 'SET_PRODUCT_FILTERS';
export const SET_ASSET_FILTER_COUNT = 'SET_ASSET_FILTER_COUNT';
export const SET_PRODUCT_FILTER_COUNT = 'SET_PRODUCT_FILTER_COUNT';
// Create Asset Page
export const TOGGLE_CREATE_ASSET_MANUALENTRY_CSVUPLOAD_VIEW = 'TOGGLE_CREATE_ASSET_MANUALENTRY_CSVUPLOAD_VIEW';

//Asset action types
export const ADD_ASSETS_DATA = 'ADD_ASSETS_DATA';
export const UPDATE_ASSETS_DATA = 'UPDATE_ASSETS_DATA';
export const REMOVE_ASSETS_DATA = 'REMOVE_ASSETS_DATA';
export const ADD_ASSET_FILES = 'ADD_ASSET_FILES';
export const REMOVE_ASSET_FILE = 'REMOVE_ASSET_FILE';
export const CHECK_ASSET_NAME_EXISTS = 'CHECK_ASSET_NAME_EXISTS';
export const APPLY_SELECTEDTAGS_TO_ALLASSETS = 'APPLY_SELECTEDTAGS_TO_ALLASSETS';
export const APPLY_SELECTEDTAG_TO_ALLASSETS = 'APPLY_SELECTEDTAG_TO_ALLASSETS';
export const REMOVE_TAGS_FROM_ALL_ASSETS = 'REMOVE_TAGS_FROM_ALL_ASSETS';
export const REMOVE_TAG_FROM_ALL_ASSETS = 'REMOVE_TAG_FROM_ALL_ASSETS';
export const RESET_ASSET_DATA = 'RESET_ASSET_DATA';
export const ASSETS_JIRA_TICKET = 'ASSETS_JIRA_TICKET';
export const DELETE_INVALID_ASSETS = 'DELETE_INVALID_ASSETS';

// Create JIRA ticket
export const TOGGLE_CREATE_JIRA_TICKET = 'TOGGLE_CREATE_JIRA_TICKET';

//files action types
export const UPDATE_FILE_REVIEW_STATUS = 'UPDATE_FILE_REVIEW_STATUS';

// tags action types
export const LOAD_TAGS_SEARCH_DATA = 'LOAD_TAGS_SEARCH_DATA';
export const ADD_TAG_SELECTED = 'ADD_TAG_SELECTED';
export const DELETE_TAG_SELECTED = 'DELETE_TAG_SELECTED';
export const REMOVE_ALLTAGS_SELECTED = 'REMOVE_ALLTAGS_SELECTED';
export const RESET_TAGS_DATA = 'RESET_TAGS_DATA';

//Snack Bar types
export const SET_SNACKBAR_STATUS = 'SET_SNACKBAR_STATUS';
export const CLEAR_SNACKBAR = 'CLEAR_SNACKBAR';

//Alert dialog:
export const OPEN_ALERT_DIALOG = 'OPEN_ALERT_DIALOG';
export const CLOSE_ALERT_DIALOG = 'CLOSE_ALERT_DIALOG';

//backdrop overlay
export const OPEN_BACKDROP_OVERLAY = 'OPEN_BACKDROP_OVERLAY';
export const CLOSE_BACKDROP_OVERLAY = 'CLOSE_BACKDROP_OVERLAY';

//Products tab
export const SET_PRODUCTS_TAB_SEARCHDATA = 'SET_PRODUCTS_TAB_SEARCHDATA';

//submitted assets
export const SET_SUBMITTED_ASSETS = 'SET_SUBMITTED_ASSETS';
export const RESET_SUBMITTED_ASSETS = 'RESET_SUBMITTED_ASSETS';

//Manage Assets
export const FETCH_MANAGEASSET_DATA = 'FETCH_MANAGEASSET_DATA';
export const MANAGE_ASSET_DELETE_TAG = 'MANAGE_ASSET_DELETE_TAG';
export const MANAGE_ASSET_ADD_TAG = 'MANAGE_ASSET_ADD_TAG';
export const MANAGE_ASSET_DELETE_ALL_TAGS = 'MANAGE_ASSET_DELETE_ALL_TAGS';
export const MANAGE_ASSET_LINK_PRODUCT = 'MANAGE_ASSET_LINK_PRODUCT';
export const MANAGE_ASSET_DELETE_ASSET = 'MANAGE_ASSET_DELETE_ASSET';
export const MANAGE_ASSET_ADD_FILES = 'MANAGE_ASSET_ADD_FILES';
export const MANAGE_ASSET_REMOVE_ALL_FILES = 'MANAGE_ASSET_REMOVE_ALL_FILES';
export const MANAGE_ASSET_CHANGE_ARTIFACT_STATUS = 'MANAGE_ASSET_CHANGE_ARTIFACT_STATUS';
export const MANAGE_ASSET_REMOVE_FILE = 'MANAGE_ASSET_REMOVE_FILE';
export const MANAGE_ASSET_SET_PRIMARY_FILE = 'MANAGE_ASSET_SET_PRIMARY_FILE';
export const MANAGE_ASSET_UPDATE_JIRA_TICKET = 'MANAGE_ASSET_UPDATE_JIRA_TICKET';
export const MANAGE_ASSET_REBUILD_SOURCE_FILE = 'MANAGE_ASSET_REBUILD_SOURCE_FILE';
export const MANAGE_ASSET_REBUILD_ARTIFACT_FILE = 'MANAGE_ASSET_REBUILD_ARTIFACT_FILE';

// Build templates
export const FETCH_BUILD_TEMPLATES = 'FETCH_BUILD_TEMPLATES';

// Manage product
export const MANAGE_PRODUCT_RESET_STATE = 'MANAGE_PRODUCT_RESET_STATE';
export const FETCH_MANAGE_PRODUCT_DATA = 'FETCH_MANAGE_PRODUCT_DATA';

// User, auth, and login
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';

// CSV import missing product IVM's
export const CSV_IMPORT_MISSING_IVMS = 'CSV_IMPORT_MISSING_IVMS';
